module.exports = __webpack_public_path__ + "img/HelpIcon.f22a018a.svg";